import { useNavigate } from 'react-router-dom';
import { Alert, Button } from '@zarya/ui';
import { t } from '@app/i18n';
import type { ApprovalDetail } from './ApprovalsModel';

/**
 * Bloqueio de FR-050: identidade descoberta sem namespace, serviceaccount ou
 * imagem **não aprova**. O alerta diz o que falta e leva a T5; Aprovar e
 * Rejeitar ficam ausentes enquanto isso.
 */
export function AssignmentBlock({ detalhe }: { detalhe: ApprovalDetail }) {
  const navigate = useNavigate();

  return (
    <Alert tone="danger" title={t('approvals.assignment.title')}>
      {t('approvals.assignment.body')}
      <div style={{ marginTop: 12 }}>
        <Button
          variant="out"
          size="sm"
          icon="robot"
          onClick={() => navigate(`/identidades?drawer=${detalhe.identity_id}`)}
        >
          {t('approvals.assignment.action')}
        </Button>
      </div>
    </Alert>
  );
}
